/**
 * Utilitário para converter caminhos relativos do Storage em URLs absolutas
 * Usado pelo widget para exibir imagens e arquivos corretamente
 * 
 * @version 1.0.0
 */

import { getSupabaseUrl } from './supabaseConfig';
import { createLogger } from '@/lib/logger';

// Logger para diagnóstico
const logger = createLogger('StorageUrl');

/**
 * Converte caminho relativo do Storage em URL absoluta pública
 * 
 * @param storagePath - Caminho relativo no bucket (ex: "Chats/uuid/file.png")
 * @param bucket - Nome do bucket (padrão: "anexos")
 * @returns URL absoluta do arquivo no Storage
 */
export function getStorageUrl(storagePath: string, bucket: string = 'anexos'): string {
  if (!storagePath) {
    logger.warn('storagePath vazio');
    return '';
  }
  
  // Se já for URL absoluta ou especial (blob/data), retornar como está
  if (
    storagePath.startsWith('http://') || 
    storagePath.startsWith('https://') ||
    storagePath.startsWith('blob:') ||
    storagePath.startsWith('data:')
  ) {
    return storagePath;
  }
  
  const supabaseUrl = getSupabaseUrl();
  if (!supabaseUrl) {
    logger.warn('URL do Supabase não configurada');
    return storagePath;
  }
  
  // Montar URL pública do Storage com encoding seguro por segmento
  // Evita problemas com caracteres especiais no nome do arquivo
  const encodedPath = storagePath
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/');
  
  const publicUrl = `${supabaseUrl}/storage/v1/object/public/${bucket}/${encodedPath}`;
  
  logger.debug('URL do storage gerada', { storagePath, publicUrl });
  return publicUrl;
}